import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

import Layout from '../components/layouts/mainLayout'
import Banner from '../components/banner'

import "../styles/dynamic-list.scss"
import "../styles/commitments.scss"
import Head from '../components/head'

const Commitments = () => {

    const data =useStaticQuery(graphql`
        query {
            allContentfulCommitments(sort: {
                fields: publishedDate,
                order:DESC
            }){
                edges {
                        node {
                            title
                            publishedDate(formatString: "MMMM Do, YYYY")
                            body {
                                json
                            }
                        }
                }
            }
            BannerImg: file(relativePath: {eq:"ms.jpg"}){
                ...FluidImageFragment
            }
        }
    `)

    const options = {
        renderNode: {
            "embedded-asset-block": (node) => {
                const alt = node.data.target.fields.title['en-US']
                const url = node.data.target.fields.file['en-US'].url
                return <img src={url} alt={alt} />
            }
        }
    }

    return (
        <Layout>
            <Head title="Commitments"/>
            <Banner 
                title="COMMITMENTS"
                img={data.BannerImg.childImageSharp.fluid}
                height="small"
            />
            <ol className="posts">
                {data.allContentfulCommitments.edges.map((edge) => (
                    <>
                        <li className="post padding">
                            <h2>Commitment Alert | {edge.node.title}</h2>
                            <div className="date">{edge.node.publishedDate}</div>
                            <div className="commitments-content">
                                {documentToReactComponents(edge.node.body.json, options)} 
                            </div>
                        </li>
                        <div className="linebreak"></div>
                    </>
                ))}
            </ol>
        </Layout>
    )
}

export default Commitments
